import type { ButtonProps } from "@braintrust/braintrust-ui-components";
import { Button } from "@braintrust/braintrust-ui-components";
import type { FreelancerOffer } from "@js/types/jobs";
import { handleDownloadFile } from "@js/utils";

type DownloadOfferButtonProps = {
  offer: Pick<FreelancerOffer, "pdf_file">;
} & Partial<Pick<ButtonProps, "variant">>;

export const DownloadOfferButton = ({
  offer,
  variant,
}: DownloadOfferButtonProps) => {
  const { pdf_file: pdfFile } = offer;
  if (!pdfFile) {
    return null;
  }

  return (
    <Button
      variant={variant ?? "transparent-border-beige"}
      shape="squared"
      type="button"
      size="medium"
      onClick={() => {
        handleDownloadFile({
          endpoint: pdfFile.file,
          blank: true,
        });
      }}
    >
      Download offer
    </Button>
  );
};
